module.exports = __webpack_public_path__ + "img/elo.35876931.jpg";